import { render, staticRenderFns } from "./FactInput.vue?vue&type=template&id=170a69c8&scoped=true&"
import script from "./FactInput.vue?vue&type=script&lang=js&"
export * from "./FactInput.vue?vue&type=script&lang=js&"
import style0 from "./FactInput.vue?vue&type=style&index=0&id=170a69c8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170a69c8",
  null
  
)

export default component.exports